import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Dot, ChevronRight } from 'react-bootstrap-icons'
import { useNavigate, useParams } from 'react-router-dom'
import CampaignsListItem from './CampaignsListItem'
import SortByDropdown from './SortByDropdown'
import { BrowseContext } from '../../../contexts/BrowseContext'

export default observer(function ClientCampaignsList() {
  const { selectedClient, selectedFolder, clientCampaigns, campaignListSort }  = useContext(BrowseContext)
  const {client_id, folder_id} = useParams()
  const navigate = useNavigate()
  const folderCampaigns = folder_id
    ? clientCampaigns.filter(camp => +camp.folder_id === +folder_id)
    : clientCampaigns

  return(
    <div className={`p-8 ${folder_id ? '' : 'pt-0'}`}>
      {
        folder_id && (
          <div className="flex items-center gap-2 mb-5">
            <button
              onClick={() => navigate('/project_manager/campaigns')}
              className='text-lg font-bold dark:text-white'
              >
              Clients
            </button>
            <ChevronRight className='font-bold text-lg rb-text-muted' />
            <button
              onClick={() => navigate(`/project_manager/campaigns/clients/${client_id}`)}
              className='text-lg font-bold dark:text-white'
            >
              {selectedClient.name}
            </button>
            <ChevronRight className='font-bold text-lg rb-text-muted' />
            <h2 className='text-lg font-bold dark:text-white'>{selectedFolder.name}</h2>
          </div>
        )
      }
      <div className="flex items-center justify-between">
        <div className='flex items-center'>
          <h2 className='font-bold text-lg dark:text-white'>{folder_id ? 'Campaigns' : 'All campaigns'}</h2>
          {folder_id && (
            <>
              <Dot className='h-7 w-7 rb-text-muted' />
              <span className='font-bold text-lg rb-text-muted'>{folderCampaigns.length}</span>
            </>
          )}
        </div>
        <SortByDropdown
          sortDirection={campaignListSort.direction}
          editSortDirection={() => campaignListSort.direction === 'desc' ? campaignListSort.direction = 'asc' : campaignListSort.direction = 'desc'}
          editSortAttribute={option => campaignListSort.attribute = option}
        />
      </div>

      <div className="grid grid-cols-3 gap-5 mt-3">
        <button
          className='text-rb-green dark:text-rb-green bg-rb-soft-green dark:bg-rb-green/20 rounded-lg border-dashed border-2 border-rb-green dark:border-rb-green h-[144px] font-bold'
          onClick={() => navigate('/project_manager/campaigns/new', { state: { client_id: selectedClient.id, folder_id: folder_id ? +folder_id : undefined } })}
        >
          Create Campaign
        </button>
        {folderCampaigns.map(campaign => (
          <CampaignsListItem key={campaign.id} campaign={campaign} />
        ))}
      </div>
    </div>
  )
})
